import {
    Component
} from '@angular/core';
import {
    ChangeDetectorRef
} from '@angular/core';
import {
    ApperyioHelperService
} from '../../scripts/apperyio/apperyio_helper';
import {
    ApperyioMappingHelperService
} from '../../scripts/apperyio/apperyio_mapping_helper';
import {
    ScreenOrientation
} from '@ionic-native/screen-orientation/ngx';
import {
    ExportedClass as NeurService
} from '../../scripts/custom/NeurService';
import {
    ExportedClass as PlaceService
} from '../../scripts/custom/PlaceService';
import * as L from 'leaflet';
import {
    PLACE_CATEGORIES
} from '../../../app/scripts/custom/PlaceCategories';
import {
    MAP_FLY_THRESHOLD
} from '../../../app/scripts/custom/NeurConstants';
import {
    MAP_MARKER_ANIMATION
} from '../../../app/scripts/custom/NeurConstants';
import {
    MAP_MARKER_POPUP
} from '../../../app/scripts/custom/NeurConstants';
import * as SunCalc from 'suncalc';
import * as moment from 'moment';
import {
    MAP_MARKER_SIZE,
    MAP_PROVIDERS,
    MAP_ZOOM_LEVEL,
    MAP_FLY_DURATION
} from '../../../app/scripts/custom/NeurConstants';
import {
    MAP_MARKER_ICON
} from '../../../app/scripts/custom/NeurConstants';
import {
    MAP_LOCATION_UPDATE
} from '../../../app/scripts/custom/NeurConstants';
import {
    CURRENT_PLACE
} from '../../../app/scripts/custom/PlaceService';
import * as turf from '@turf/turf';
import proj4 from 'proj4';
import {
    ACTION_ICONS
} from '../../../app/scripts/custom/NeurConstants';
import {
    v4 as uuidv4
} from 'uuid';
import {
    $aio_empty_object
} from '../../scripts/interfaces';
import {
    Input
} from '@angular/core';
import {
    Output
} from '@angular/core';
import {
    EventEmitter
} from '@angular/core';
import {
    ControlValueAccessor
} from '@angular/forms';
import {
    NG_VALUE_ACCESSOR
} from '@angular/forms';
import {
    NG_VALIDATORS
} from '@angular/forms';
import {
    Validator
} from '@angular/forms';
import {
    AbstractControl
} from '@angular/forms';
import {
    ValidationErrors
} from '@angular/forms';
import {
    forwardRef
} from '@angular/core';
import {
    ViewChild
} from '@angular/core';
@Component({
    templateUrl: 'PlaceMapView.html',
    selector: 'component-place-map-view',
    styleUrls: ['PlaceMapView.css', 'PlaceMapView.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PlaceMapView),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PlaceMapView),
            multi: true,
        },
    ]
})
export class PlaceMapView implements ControlValueAccessor, Validator {
    public mapOSM: any;
    public _flying: boolean;
    public _containerReady: boolean;
    public routingControl: any;
    public offerMarkersIconGroup: any;
    public offerMarkersDotGroup: any;
    public placeMarkerGroup: any;
    public sun_ray_line: any;
    public base_level: number;
    public currentLocationMarker: any;
    public previousViewPlace: any;
    public _changingMap: boolean;
    public currentCenter: any;
    public infoBoxControl: any;
    public itineraryHighlightRow: any;
    public currentZoom: number;
    public markersAdded: any;
    public _isMyLocationInView: boolean;
    public _markerPopup: boolean;
    public placeDataMarkerGroup: any;
    public $a: ApperyioHelperService;
    public $v: {
        [name: string]: any
    };
    public aioChangeDetector: ChangeDetectorRef;
    public currentItem: any = null;
    public mappingData: any = {};
    public __getMapping(_currentItem, property, defaultValue, isVariable?, isSelected?) {
        return this.$aio_mappingHelper.getMapping(this.mappingData, _currentItem, property, defaultValue, isVariable, isSelected);
    }
    public __isPropertyInMapping(_currentItem, property) {
        return this.$aio_mappingHelper.isPropertyInMapping(this.mappingData, _currentItem, property);
    }
    public __setMapping(data: any = {}, keyName: string, propName?: string): void {
        const changes = data.detail || {};
        if (propName) {
            this.mappingData = this.$aio_mappingHelper.updateData(this.mappingData, [keyName], changes[propName]);
        } else {
            this.mappingData = this.$aio_mappingHelper.updateData(this.mappingData, [keyName], changes.value);
        }
        this.$aio_changeDetector.detectChanges();
    }
    public __bindedMethods: any = {};
    @Output() public centerView: any = new EventEmitter();
    @Input() public marker_popup: any;
    @Input() public view_time: any;
    @Input() public search_filter: any;
    @Input() public _flyToDestination: any;
    @Output() public unselectPlace: any = new EventEmitter();
    @Output() public _myLocationInView: any = new EventEmitter();
    @Input() public offer_list: any;
    @Output() public actionItemId: any = new EventEmitter();
    @Input() public place_data: any;
    @Input() public mapPlace: any;
    @Output() public clickedIndex: any = new EventEmitter();
    @Output() public selectedIndex: any = new EventEmitter();
    @Input() public place: any;
    @Input() public poi_coordinates: any;
    /**
     * A callback executed when the content of the editor changes. Part of the
     * `ControlValueAccessor` (https://angular.io/api/forms/ControlValueAccessor) interface.
     *
     * Note: Unset unless the component uses the `ngModel`.
     */
    public ngModelOnChange?: (data: any) => void;
    /**
     * A callback executed when the editor has been blurred. Part of the
     * `ControlValueAccessor` (https://angular.io/api/forms/ControlValueAccessor) interface.
     *
     * Note: Unset unless the component uses the `ngModel`.
     */
    public ccOnTouched?: () => void;
    // Implementing the ControlValueAccessor interface (only when binding to ngModel).
    public writeValue(value: any | null): void {}
    // Implementing the ControlValueAccessor interface (only when binding to ngModel).
    public registerOnChange(callback: (data: any) => void): void {
        this.ngModelOnChange = callback;
    }
    // Implementing the ControlValueAccessor interface (only when binding to ngModel).
    public registerOnTouched(callback: () => void): void {
        this.ccOnTouched = callback;
    }
    // Implementing the ControlValueAccessor interface (only when binding to ngModel).
    public setDisabledState(isDisabled: boolean): void {}
    validate(control: AbstractControl): ValidationErrors | null {
        return null;
    }
    ngAfterViewInit(): any {
        //this._containerReady = true;
        setTimeout(() => {
            // this.showMap(this.pjavascript:void(0);lace,this.offer_list);
            this.createMap(this.place);
        }, 500);
        /**
        proj4.defs('EPSG:4326', '+proj=longlat +datum=WGS84 +no_defs'); // WGS84 (longitude, latitude)
        proj4.defs('EPSG:3857', '+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext +no_defs'); // Web Mercator (X, Y)
        /**/
        /*
        var elementMapView = document.getElementById(this.mapPlace);
        if (elementMapView){
            elementMapView.addEventListener('viewMap',this.showMap.bind(this));  
            elementMapView.addEventListener('centeredAtPOI',this.centered_at_poi.bind(this));
        }
        */
    }
    ngOnChanges(changes): any {
        if (changes.place && !changes.place.firstChange) {
            this.updateMapView(this.place);
            //    this._changingMap = true;
        }
        if (changes.offer_list && !changes.offer_list.firstChange) {
            if (this.offer_list && this.offer_list.length > 0) {
                console.log("updating markers by offer_list ...")
                this.updateOfferMarkers(this.offer_list, this.place.itinerarySummary);
            }
            //        this.showMap(this.place, this.offer_list);
        }
        if (changes.place_data && !changes.place_data.firstChange) {
            if (this.place_data.data_list && this.place_data.data_list.length > 0) {
                this.updatePlaceData(this.place_data);
            }
        }
        if (changes.poi_coordinates && this.mapOSM) {
            if (this._markerPopup) {
                this._markerPopup = false;
            } else {
                this.centered_at_poi();
            }
        }
        if (changes.view_time && this.mapOSM) {
            this.show_sun_ray();
        }
    }
    async createMap(place): Promise < any > {
        this.markersAdded = new Set();
        this.offerMarkersIconGroup = L.featureGroup();
        this.offerMarkersDotGroup = L.featureGroup();
        this.placeMarkerGroup = L.featureGroup();
        this.placeDataMarkerGroup = L.featureGroup();
        let self = this;
        if (this._flyToDestination) {
            this.mapOSM = this.neurService.createLeafletMap(this.mapPlace, place.coordinates, place.zoom_level);
            this.mapOSM._handlers.forEach(function(handler) {
                handler.disable();
            });
            this.mapOSM.flyTo([place.coordinates.latitude, place.coordinates.longitude], place.zoom_level, {
                duration: MAP_FLY_DURATION.CURRENT_TO_DESTINATION
            })
            await new Promise(resolve => setTimeout(resolve, MAP_FLY_DURATION.CTD_WAIT));
            this.mapOSM._handlers.forEach(function(handler) {
                handler.enable();
            });
        } else {
            this.mapOSM = this.neurService.createLeafletMap(this.mapPlace, place.coordinates, place.zoom_level);
        }
        if (this.neurService._locationBasedOnGeo) {
            this.currentLocationMarker = L.marker([this.neurService.current_location.latitude, this.neurService.current_location.longitude], {
                icon: L.icon({
                    iconUrl: MAP_MARKER_ICON.CUR_LOC,
                    iconSize: [MAP_MARKER_SIZE.CUR_LOC, MAP_MARKER_SIZE.CUR_LOC]
                }),
                draggable: false
            }).addTo(this.mapOSM);
            checkCurrentLocationInView();
            setInterval(function() {
                if (self.neurService.distanceFromTo(self.currentLocationMarker.getLatLng(), {
                        lat: self.neurService.current_location.latitude,
                        lng: self.neurService.current_location.longitude
                    }) > MAP_LOCATION_UPDATE.THRESHOLD) {
                    self.currentLocationMarker.setLatLng([self.neurService.current_location.latitude, self.neurService.current_location.longitude]);
                }
            }, MAP_LOCATION_UPDATE.FREQUENCY);
        }
        this.mapOSM.addLayer(this.placeDataMarkerGroup);
        this.getPlaceData(place.zoom_level);
        this.screenOrientation.onChange().subscribe(() => {
            setTimeout(() => {
                if (self.mapOSM) {
                    self.mapOSM.invalidateSize();
                }
            }, 200);
        });
        //**            // Call the function whenever the map zoom changes
        //**            this.mapOSM.on('zoomend', onMapZoomed);
        // Add an event listener to the 'move' event of the map
        this.mapOSM.on('moveend', onMapMoved);
        /**
                    function onMapZoomed() {
                        checkCurrentLocationInView();
                        self.getPlaceData();
                        self.showMarkers(self.mapOSM.getZoom());
                    }
        **/
        function onMapMoved() {
            checkCurrentLocationInView();
            self.getPlaceData();
        }

        function checkCurrentLocationInView() {
            if (self.currentLocationMarker) {
                const mapBounds = self.mapOSM.getBounds();
                const markerLatLng = self.currentLocationMarker.getLatLng();
                let _isMyLocationInView = mapBounds.contains(markerLatLng);
                if (self._isMyLocationInView != _isMyLocationInView) {
                    self._isMyLocationInView = _isMyLocationInView;
                    self._myLocationInView.emit(_isMyLocationInView);
                }
            }
        }
    }
    explored(point, zoom_level): any {
        let exploredArea = this.placeService.getExploredArea(zoom_level);
        let requestedArea = this.placeService.getRequestedArea(zoom_level);
        let turfPoint = Array.isArray(point)? turf.point(point): turf.point([point.lng, point.lat]);
        let _explored = false;
        if (exploredArea) {
            _explored = turf.booleanPointInPolygon(turfPoint, exploredArea);
        }
        let _requested = false;
        if (requestedArea) {
            for (const [requestID, area] of requestedArea.entries()) {
                if (turf.booleanPointInPolygon(turfPoint, area)) {
                    _requested = true;
                    break; // Exit the loop if the point is inside any area
                }
            }
        }
        return (_explored || _requested)
    }
    updateMapView(place): any {
        if (this.mapOSM) {
            this.clearMarkers();
            this.mapOSM.setView([place.coordinates.latitude, place.coordinates.longitude], place.zoom_level);
        }
    }
    updateOfferMarkers(offer_list, itinerarySummary): any {
        if (this.place._id > 0) {
            if (Array.isArray(this.place.coordinates)) {
                this.place.coordinates.forEach((item, index) => {
                    const placeMarker = L.marker([item.coordinates.latitude, item.coordinates.longitude], {
                        icon: L.icon({
                            iconUrl: item.map_marker.pin,
                            iconSize: [MAP_MARKER_SIZE.PIN, MAP_MARKER_SIZE.PIN]
                        })
                    });
                    this.placeMarkerGroup.addLayer(placeMarker);
                });
            } else {
                this.placeMarkerGroup.addLayer(L.marker([this.place.coordinates.latitude, this.place.coordinates.longitude], {
                    icon: L.icon({
                        iconUrl: this.place.map_marker.pin,
                        iconSize: [MAP_MARKER_SIZE.PIN, MAP_MARKER_SIZE.PIN]
                    })
                }));
            }
        }
        let self = this;
        var action_icon;
        var zoomLevel = this.mapOSM.getZoom();
        offer_list.forEach((item, index) => {
            if (item.start) {
                action_icon = "assets/images/move.svg";
            } else {
                action_icon = "assets/images/bookmark.svg"
            }
            item.action_icon = action_icon;
            if (!this.markersAdded.has(item._id)) {
                if (Array.isArray(item.coordinates)) {
                    item.coordinates.forEach((coordinates) => {
                        addIconMarkers(item, coordinates);
                    });
                } else {
                    addIconMarkers(item, item.coordinates);
                }
                if (Array.isArray(item.coordinates)) {
                    item.coordinates.forEach((coordinates) => {
                        addDotMarkers(item, coordinates);
                    });
                } else {
                    addDotMarkers(item, item.coordinates);
                }
                this.markersAdded.add(item._id);
            }
        });
        // this.mapOSM.addLayer(this.offerMarkersIconGroup);
        this.showMarkers(zoomLevel);
        if (itinerarySummary) {
            this.infoBoxControl = L.control({
                position: 'topleft'
            });
            this.infoBoxControl.onAdd = function(map) {
                // Create the container for the side box
                const container = L.DomUtil.create('div', 'custom-control-class');
                // Add your content to the container (directions, information, etc.)
                container.innerHTML = itinerarySummary;
                container.addEventListener('click', event => {
                    const clickedElement = event.target;
                    if (clickedElement.classList.contains('TimeColumn') || clickedElement.classList.contains('PlaceColumn')) {
                        const className = clickedElement.classList.item(0);
                        const itemId = clickedElement.getAttribute('id' + className);
                        const markers = self.offerMarkersIconGroup.getLayers();
                        let poiLatLng = markers[itemId].getLatLng();
                        self.mapOSM.setView([poiLatLng.lat, poiLatLng.lng], self.mapOSM.getZoom());
                        setTimeout(() => {
                            markers[itemId].openPopup();
                        }, 500);
                    }
                });
                return container;
            };
            this.infoBoxControl.addTo(this.mapOSM);
        }

        function addIconMarkers(item, coordinates) {
            const placeMarker = L.marker([coordinates.latitude, coordinates.longitude], {
                icon: L.icon({
                    iconUrl: item.map_marker.icon,
                    iconSize: [MAP_MARKER_SIZE.ICON, MAP_MARKER_SIZE.ICON]
                }),
                _id: item._id
            });
            addMarkerPopup(placeMarker, item);
            placeMarker.on('popupopen', (e) => offerMarkerOnOpen(e, placeMarker));
            placeMarker.on('popupclose', (e) => offerMarkerOnClose(e, placeMarker));
            self.placeService.addMarker(zoomLevel, placeMarker);
            self.offerMarkersIconGroup.addLayer(placeMarker);
        }

        function addDotMarkers(item, coordinates) {
            const dotMarker = L.marker([coordinates.latitude, coordinates.longitude], {
                icon: L.icon({
                    iconUrl: item.map_marker.dot,
                    iconSize: [MAP_MARKER_SIZE.DOT, MAP_MARKER_SIZE.DOT]
                }),
                _id: item._id
            });
            addMarkerPopup(dotMarker, item);
            dotMarker.on('popupopen', (e) => offerMarkerOnOpen(e, dotMarker));
            dotMarker.on('popupclose', (e) => offerMarkerOnClose(e, dotMarker));
            self.offerMarkersDotGroup.addLayer(dotMarker);
        }

        function addMarkerPopup(placeMarker, item) {
            switch (self.marker_popup) {
                case MAP_MARKER_POPUP.PLACE_NAME:
                    placeMarker.bindPopup(item.name[0], {
                        closeButton: false
                    });
                    break;
                case MAP_MARKER_POPUP.PLACE_CARD:
                    /*
                                    var popupContent = `
                                                <div class="popup_content">
                                                <img class="image" src=${item.image_landscape} alt="">
                                                <div class="name">${item.name[0]}</div>
                                                <div class="time">${item.start?item.start.format("HH:mm")+ '-':''} ${item.end?item.end.format("HH:mm"):''}</div>
                                                <ion-icon class="Action" idAction = ${item._id} src="data:image/svg+xml;utf-8,${encodeURIComponent(item.action_icon)}" 
                                                size="small"></ion-icon>
                                                </div>
                                        `;
                    */
                    var popupContent = `
                            <div class="popup_content">
                            <img class="image" src=${item.image_landscape} alt="">
                            <div class="name">${item.name[0]}</div>
                            <div class="time">${item.start?item.start.format("HH:mm")+ '-':''} ${item.end?item.end.format("HH:mm"):''}</div>
                            <ion-icon class="Action" idAction = ${item._id} src="${item.action_icon}" 
                            size="small"></ion-icon>
                            </div>
                    `;
                    placeMarker.bindPopup(popupContent, {
                        closeButton: false,
                        className: 'popup_content'
                    });
                    break;
                default:
                    placeMarker.bindPopup(item.name[0], {
                        closeButton: false
                    });
                    break;
            }
        }

        function onClickOpenedPopup(event) {
            /*
            console.log("emitting selected index "+index);
                                    self.selectedIndex.emit(index);
            */
            if (self.marker_popup == MAP_MARKER_POPUP.PLACE_CARD) {
                const clickedElement = event.target;
                if (clickedElement.classList.contains('Action')) {
                    const className = clickedElement.classList.item(0);
                    const itemId = clickedElement.getAttribute('id' + className);
                    self.actionItemId.emit(itemId);
                }
            }
        }

        function offerMarkerOnOpen(e, marker) {
            var markersGroup;
            if (self.mapOSM.hasLayer(self.offerMarkersIconGroup)) {
                markersGroup = self.offerMarkersIconGroup;
            } else if (self.mapOSM.hasLayer(self.offerMarkersDotGroup)) {
                markersGroup = self.offerMarkersDotGroup;
            }
            let index = markersGroup.getLayers().indexOf(marker);
            if (itinerarySummary) {
                if (self.itineraryHighlightRow) self.itineraryHighlightRow.classList.remove('highlight');
                self.itineraryHighlightRow = document.getElementById('itemIndex' + index);
                if (self.itineraryHighlightRow) {
                    self.itineraryHighlightRow.classList.add('highlight');
                }
            }
            self.clickedIndex.emit(index);
            self._markerPopup = true;
            const popup = marker.getPopup().getElement();
            popup.addEventListener('click', onClickOpenedPopup);
        }

        function offerMarkerOnClose(e, marker) {
            var markersGroup;
            if (self.mapOSM.hasLayer(self.offerMarkersIconGroup)) {
                markersGroup = self.offerMarkersIconGroup;
            } else if (self.mapOSM.hasLayer(self.offerMarkersDotGroup)) {
                markersGroup = self.offerMarkersDotGroup;
            }
            let index = markersGroup.getLayers().indexOf(marker);
            if (itinerarySummary) {
                if (self.itineraryHighlightRow) self.itineraryHighlightRow.classList.remove('highlight');
            }
            const popup = marker.getPopup().getElement();
            popup.removeEventListener('click', onClickOpenedPopup);
        }
    }
    showMarkers(zoomLevel): any {
        var iconZoomLevel;
        switch (this.place.category) {
            case PLACE_CATEGORIES.Continent.id:
                iconZoomLevel = MAP_ZOOM_LEVEL.LARGEST_COUNTRY;
                break;
            case PLACE_CATEGORIES.Country.id:
                iconZoomLevel = MAP_ZOOM_LEVEL.AFRICAN_COUNTRY;
                break;
            case PLACE_CATEGORIES.Region.id:
            case PLACE_CATEGORIES.StateProvince.id:
                iconZoomLevel = MAP_ZOOM_LEVEL.METROPOLITAN;
                break;
            case PLACE_CATEGORIES.City.id:
                iconZoomLevel = MAP_ZOOM_LEVEL.CITY_DISTRICT;
                break;
            default:
                iconZoomLevel = MAP_ZOOM_LEVEL.CITY_DISTRICT;
                break;
        }
        if (zoomLevel >= iconZoomLevel) {
            if (this.mapOSM.hasLayer(this.offerMarkersDotGroup)) this.mapOSM.removeLayer(this.offerMarkersDotGroup);
            if (this.mapOSM.hasLayer(this.placeMarkerGroup)) this.mapOSM.removeLayer(this.placeMarkerGroup);
            if (!this.mapOSM.hasLayer(this.offerMarkersIconGroup)) this.mapOSM.addLayer(this.offerMarkersIconGroup);
        } else if (zoomLevel >= iconZoomLevel - MAP_ZOOM_LEVEL.MARKER_THRESHOLD) {
            if (this.mapOSM.hasLayer(this.offerMarkersIconGroup)) this.mapOSM.removeLayer(this.offerMarkersIconGroup);
            if (this.mapOSM.hasLayer(this.placeMarkerGroup)) this.mapOSM.removeLayer(this.placeMarkerGroup);
            if (!this.mapOSM.hasLayer(this.offerMarkersDotGroup)) this.mapOSM.addLayer(this.offerMarkersDotGroup);
        } else {
            if (this.mapOSM.hasLayer(this.offerMarkersIconGroup)) this.mapOSM.removeLayer(this.offerMarkersIconGroup);
            if (this.mapOSM.hasLayer(this.offerMarkersDotGroup)) this.mapOSM.removeLayer(this.offerMarkersDotGroup);
            if (!this.mapOSM.hasLayer(this.placeMarkerGroup)) this.mapOSM.addLayer(this.placeMarkerGroup);
        }
    }
    clearMarkers(): any {
        let self = this;
        if (this.infoBoxControl) {
            this.infoBoxControl.remove();
        }
        this.mapOSM.eachLayer(function(layer) {
            if (layer instanceof L.FeatureGroup) {
                // Remove the marker group from the map
                layer.clearLayers();
                //                self.mapOSM.removeLayer(layer);
            }
        });
        //    this.savedMarkersAdded = new Set();
        this.markersAdded = new Set();
    }
    async centered_at_poi(): Promise < any > {
        if (this.poi_coordinates && (!this._flying)) {
            let coordinates = [this.poi_coordinates.latitude, this.poi_coordinates.longitude];
            let center = this.mapOSM.getCenter();
            /**
        if (this.marker_popup == MAP_MARKER_POPUP.PLACE_NAME) {
            let distance;

            if (this.neurService.getLeafletBaseMap() == MAP_PROVIDERS.LEAFLET_BASEMAP.BAIDU) {
                let dest = L.latLng(coordinates[0], coordinates[1]);
                let org = L.latLng(center.lat, center.lng);
                distance = L.CRS.EPSG3857.distance(dest, org)
            } else {
                distance = center.distanceTo(coordinates);
            }

            if ((this.mapOSM.getZoom() < MAP_ZOOM_LEVEL.STREET) || distance > MAP_FLY_THRESHOLD.STREET) {
                this.mapOSM.flyTo(coordinates, MAP_ZOOM_LEVEL.STREET, {
                    duration: MAP_FLY_DURATION.CITY_TO_SITE
                });
                await new Promise(resolve => setTimeout(resolve, MAP_FLY_DURATION.CTS_WAIT));
            }
        }
        else if (this.marker_popup == MAP_MARKER_POPUP.PLACE_CARD){
            this.mapOSM.setView(coordinates, this.mapOSM.getZoom());
        }
    /**/
            this.mapOSM.setView(coordinates, this.mapOSM.getZoom());
            let self = this;
            var markersGroup;
            if (this.mapOSM.hasLayer(this.offerMarkersIconGroup)) {
                markersGroup = this.offerMarkersIconGroup;
            } else if (this.mapOSM.hasLayer(this.offerMarkersDotGroup)) {
                markersGroup = this.offerMarkersDotGroup;
            }
            if (markersGroup) {
                markersGroup.eachLayer(function(layer) {
                    if (layer.getLatLng().equals(coordinates)) {
                        var marker = layer;
                        /*
                        var flashInterval = setInterval(function(){
                            marker.setOpacity(marker.options.opacity ? 0 : 1);
                        }, MAP_MARKER_ANIMATION.FLASH_INTERVAL);
                        */
                        setTimeout(() => {
                            marker.openPopup();
                        }, 500);
                        if (self.marker_popup != MAP_MARKER_POPUP.PLACE_CARD) {
                            setTimeout(function() {
                                marker.closePopup();
                                //clearInterval(flashInterval);
                            }, MAP_MARKER_ANIMATION.FLASH_DURATION);
                            //marker.setOpacity(1);
                        }
                    }
                });
            }
        } else {
            this.mapOSM.closePopup();
        }
    }
    show_sun_ray(): any {
        if (this.sun_ray_line) this.mapOSM.removeLayer(this.sun_ray_line);
        if (this.view_time) {
            // Get the latitude and longitude of the center of the map
            const center = this.mapOSM.getCenter();
            // Get the sun's position using suncalc
            const sunPosition = SunCalc.getPosition(this.view_time, center.lat, center.lng);
            if (sunPosition.altitude > 0) {
                const sunLatLng = L.latLng(center.lat + Math.cos(sunPosition.altitude) * Math.cos(sunPosition.azimuth + Math.PI),
                    center.lng + Math.cos(sunPosition.altitude) * Math.sin(sunPosition.azimuth + Math.PI));
                // Create a polyline from the center of the map to the calculated endpoint
                this.sun_ray_line = L.polyline([
                    [center.lat, center.lng], sunLatLng
                ], {
                    color: 'orange',
                    weight: 2
                }).addTo(this.mapOSM);
            }
        }
    }
    zoomedInPlace(): any {
        const markers = this.offerMarkersIconGroup.getLayers(); // Get all layers, including markers
        // Get the view screen bounds
        const viewScreenBounds = this.mapOSM.getBounds();
        // Find the markers within the view screen bounds
        const markersWithinViewScreen = markers.filter((marker) =>
            marker instanceof L.Marker && viewScreenBounds.contains(marker.getLatLng())
        );
        if (markersWithinViewScreen.length === 1) {
            // Get the single marker's index within the 'markers' array
            const markerIndex = markers.indexOf(markersWithinViewScreen[0]);
            this.selectedIndex.emit(markerIndex);
            return true;
        }
        return false;
    }
    getPlaceData(zoomLevel?): any {
        let self = this;
        var zoom_level;
        const center = this.mapOSM.getCenter();
        if (!zoomLevel) {
            zoom_level = this.mapOSM.getZoom();
        } else {
            zoom_level = zoomLevel;
        }
        const mapSize = this.mapOSM.getSize();
        let lngDifference = this.mapOSM.containerPointToLatLng(L.point(mapSize.x, 0)).lng - center.lng;
        let latDifference = this.mapOSM.containerPointToLatLng([0, 0]).lat - center.lat;
        const bounds = L.latLngBounds(L.latLng(Math.max(-90, center.lat - 3 * latDifference), center.lng - 3 * lngDifference), L.latLng(Math.min(90, center.lat + 3 * latDifference), center.lng + 3 * lngDifference));
        let coordinates = [];
        if (!this.explored(center, zoom_level)) {
            let turfRing = [];
            let tiles = [];
            let centerTile = {
                lat: center.lat,
                lng: center.lng,
                sw: L.latLng(Math.max(-90, (center.lat - latDifference)), center.lng - lngDifference),
                ne: L.latLng(Math.min(90, (center.lat + latDifference)), center.lng + lngDifference)
            }
            let northTile = {
                lat: Math.min(90, center.lat + 2 * latDifference),
                lng: center.lng,
                sw: L.latLng(Math.min(90, center.lat + latDifference), center.lng - lngDifference),
                ne: L.latLng(Math.min(90, center.lat + 3 * latDifference), center.lng + lngDifference)
            }
            tiles.push(northTile);
            let northWestTile = {
                lat: Math.min(90, center.lat + 2 * latDifference),
                lng: center.lng - 2 * lngDifference,
                sw: L.latLng(Math.min(90, center.lat + latDifference), center.lng - 3 * lngDifference),
                ne: L.latLng(Math.min(90, center.lat + 3 * latDifference), center.lng - lngDifference)
            }
            tiles.push(northWestTile);
            let westTile = {
                lat: center.lat,
                lng: center.lng - 2 * lngDifference,
                sw: L.latLng(Math.max(-90, center.lat - latDifference), center.lng - 3 * lngDifference),
                ne: L.latLng(Math.min(90, center.lat + latDifference), center.lng - lngDifference)
            }
            tiles.push(westTile);
            let southWestTile = {
                lat: Math.max(-90, center.lat - 2 * latDifference),
                lng: center.lng - 2 * lngDifference,
                sw: L.latLng(Math.max(-90, center.lat - 3 * latDifference), center.lng - 3 * lngDifference),
                ne: L.latLng(Math.max(-90, center.lat - latDifference), center.lng - lngDifference)
            }
            tiles.push(southWestTile);
            let southTile = {
                lat: Math.max(-90, center.lat - 2 * latDifference),
                lng: center.lng,
                sw: L.latLng(Math.max(-90, center.lat - 3 * latDifference), center.lng - lngDifference),
                ne: L.latLng(Math.max(-90, center.lat - latDifference), center.lng + lngDifference)
            }
            tiles.push(southTile);
            let southEastTile = {
                lat: Math.max(-90, center.lat - 2 * latDifference),
                lng: center.lng + 2 * lngDifference,
                sw: L.latLng(Math.max(-90, center.lat - 3 * latDifference), center.lng + lngDifference),
                ne: L.latLng(Math.max(-90, center.lat - latDifference), center.lng + 3 * lngDifference)
            }
            tiles.push(southEastTile);
            let eastTile = {
                lat: center.lat,
                lng: center.lng + 2 * lngDifference,
                sw: L.latLng(Math.max(-90, center.lat - latDifference), center.lng + lngDifference),
                ne: L.latLng(Math.min(90, center.lat + latDifference), center.lng + 3 * lngDifference)
            }
            tiles.push(eastTile);
            let northEastTile = {
                lat: Math.min(90, center.lat + 2 * latDifference),
                lng: center.lng + 2 * lngDifference,
                sw: L.latLng(Math.min(90, center.lat + latDifference), center.lng + lngDifference),
                ne: L.latLng(Math.min(90, center.lat + 3 * latDifference), center.lng + 3 * lngDifference)
            }
            tiles.push(northEastTile);
            let [mapPt, turfPt] = getPts(centerTile);
            if (!this.explored(turfPt, zoom_level)) {
                coordinates.push(mapPt);
                tiles.forEach((tile) => {
                    [mapPt, turfPt] = getPts(tile)
                    turfRing.push(turfPt);
                    if (mapPt[0][1] < 90 && mapPt[1][1] > -90) {
                        if (!this.explored(turfPt, zoom_level)) {
                            coordinates.push(mapPt);
                        }
                    }
                });
            } else {
                tiles.forEach((tile) => {
                    [mapPt, turfPt] = getPts(tile)
                    turfRing.push(turfPt);
                });
            }
            turfRing.push([northTile.lng, northTile.lat]);
            //const bounds = L.latLngBounds(southWestTile.sw, northEastTile.ne);
            if (coordinates.length > 0) {
                let turfViewArea = turf.polygon([turfRing]);
                let requestId = uuidv4();
                let requestedAreas = this.placeService.getRequestedArea(zoom_level);
                requestedAreas.set(requestId, turfViewArea);
                this.placeService.setRequestedArea(zoom_level, requestedAreas);
                this.centerView.emit({
                    center: {
                        latitude: center.lat,
                        longitude: center.lng
                    },
                    coordinates: coordinates,
                    zoom_level: zoom_level,
                    request_id: requestId,
                    center_bounds: L.latLngBounds(centerTile.sw, centerTile.ne),
                    bounds: bounds
                });
            }
        }
        this.loadMarkers(zoom_level, bounds, coordinates.length == 0);

        function getPts(tile) {
            let mapPt, wrapMapPt;
            if ((tile.sw.lng >= -180) && (tile.ne.lng <= 180)) {
                mapPt = [
                    [tile.sw.lng, tile.sw.lat],
                    [tile.ne.lng, tile.ne.lat]
                ];
            } else if (tile.ne.lng <= -180) {
                mapPt = [
                    [360 + tile.sw.lng, tile.sw.lat],
                    [360 + tile.ne.lng, tile.ne.lat]
                ];
            } else if (tile.sw.lng >= 180) {
                mapPt = [
                    [-360 + tile.sw.lng, tile.sw.lat],
                    [-360 + tile.ne.lng, tile.ne.lat]
                ];
            } else if (tile.sw.lng < -180 && tile.ne.lng > -180) {
                mapPt = [
                    [-180, tile.sw.lat],
                    [tile.ne.lng, tile.ne.lat]
                ];
                wrapMapPt = [
                    [360 + tile.sw.lng, tile.sw.lat],
                    [180, tile.ne.lat]
                ];
            } else if (tile.sw.lng < 180 && tile.ne.lng > 180) {
                mapPt = [
                    [tile.sw.lng, tile.sw.lat],
                    [180, tile.ne.lat]
                ];
                wrapMapPt = [
                    [-180, tile.sw.lat],
                    [-360 + tile.ne.lng, tile.ne.lat]
                ];
            }
            let turfPt, wrapTurfPt;
            if ((tile.lng >= -180) && (tile.lng <= 180)) {
                turfPt = [tile.lng, tile.lat];
            } else if (tile.lng < -180) {
                turfPt = [-180, tile.lat];
                wrapTurfPt = [360 + tile.lng, tile.lat];
            } else if (tile.lng > 180) {
                turfPt = [180, tile.lat];
                wrapTurfPt = [-360 + tile.lng, tile.lat];
            }
            return [mapPt, turfPt];
        }
    }
    updatePlaceData(place_data): any {
        let self = this;
        if (place_data.data_list != null) {
            for (let i = 0; i < place_data.data_list.length; i++) {
                this.addMarkers(place_data.zoom_level, place_data.data_list[i], place_data.data_list[i].coordinates);
            };
            if (this.mapOSM.getZoom() == place_data.zoom_level) {
                this.loadMarkers(place_data.zoom_level, place_data.bounds, true);
            }
            if (place_data.request_complete) {
                let exploredArea = this.placeService.getExploredArea(place_data.zoom_level);
                let requestedAreas = this.placeService.getRequestedArea(place_data.zoom_level);
                let requestedArea = requestedAreas.get(place_data.request_id);
                if (exploredArea) {
                    if (place_data.data_list != null) {
                        exploredArea = turf.union(exploredArea, requestedArea);
                    }
                } else {
                    exploredArea = requestedArea;
                }
                requestedAreas.delete(place_data.request_id);
                this.placeService.setExploredArea(place_data.zoom_level, exploredArea);
                this.placeService.setRequestedArea(place_data.zoom_level, requestedAreas);
            }
        }
    }
    async showMapSS(place, offer_list): Promise < any > {
        /*
    let _update = false;

    let self = this;

    let zoomLevel = place.zoom_level;
    let turfArea = place.turfArea;
    let currentRequest = place.currentRequest;

    let turfExploredArea = this.placeService.getTurfExploredArea(zoomLevel);
    this.base_level = zoomLevel;

    if (!this.mapOSM) {
        this.markersAdded = new Set();
        this.savedMarkersAdded = new Set();
        this.offerMarkersIconGroup = L.featureGroup();
        this.offerMarkersDotGroup = L.featureGroup();
        this.placeMarkerGroup = L.featureGroup();
        this.savedMarkersIconGroup = L.featureGroup();

        if (this._flyToDestination) {
            this._flying = true;
            this.mapOSM = this.neurService.createLeafletMap(self.mapPlace, this.neurService.current_location, zoomLevel);
            this.mapOSM._handlers.forEach(function(handler) {
                handler.disable();
            });
            this.mapOSM.flyTo([place.coordinates.latitude, place.coordinates.longitude], zoomLevel, {
                duration: MAP_FLY_DURATION.CURRENT_TO_DESTINATION
            })
        } else {
            this.mapOSM = this.neurService.createLeafletMap(self.mapPlace, place.coordinates, zoomLevel);
        }

        if (this.neurService._locationBasedOnGeo) {
            this.currentLocationMarker = L.marker([this.neurService.current_location.latitude, this.neurService.current_location.longitude], {
                icon: L.icon({
                    iconUrl: MAP_MARKER_ICON.CUR_LOC,
                    iconSize: [MAP_MARKER_SIZE.CUR_LOC, MAP_MARKER_SIZE.CUR_LOC]
                }),
                draggable: false
            }).addTo(this.mapOSM);

            setInterval(function() {
                if (self.neurService.distanceFromTo(self.currentLocationMarker.getLatLng(), {
                        lat: self.neurService.current_location.latitude,
                        lng: self.neurService.current_location.longitude
                    }) > MAP_LOCATION_UPDATE.THRESHOLD) {
                    self.currentLocationMarker.setLatLng([self.neurService.current_location.latitude, self.neurService.current_location.longitude]);
                    //map.setView([lat, lng], 16);
                }
            }, MAP_LOCATION_UPDATE.FREQUENCY);
        }

    } else {
        _update = true;

        if (this.infoBoxControl) {
            this.infoBoxControl.remove();
        }

        if (this._changingMap || place._clearMarkers) {
            /*
                this.mapOSM.eachLayer(function(layer) {
                if (layer instanceof L.FeatureGroup) {
                    // Remove the marker group from the map
                    layer.clearLayers();
                    self.mapOSM.removeLayer(layer);
                }
                
            }); *
            this.placeMarkerGroup.clearLayers();
            this.mapOSM.removeLayer(this.placeMarkerGroup);
            this.offerMarkersIconGroup.clearLayers();
            this.mapOSM.removeLayer(this.offerMarkersIconGroup);
            this.offerMarkersDotGroup.clearLayers();
            this.mapOSM.removeLayer(this.offerMarkersDotGroup);
            this.markersAdded = new Set();
        }
    }

    /*
        if (this._flyToDestination) {
            await new Promise(resolve => setTimeout(resolve, MAP_FLY_DURATION.CTD_WAIT));
        }

    */
        /*
                    const deleteButton = document.getElementById(index);
                    deleteButton.addEventListener('click', (event) => {
                        event.stopPropagation(); // Prevent click event from bubbling up
                        onClickDelete(index);
                    });
    *

    function onClickOpenedPopup(event) {
        /*
        console.log("emitting selected index "+index);
                                self.selectedIndex.emit(index);
        *
        if (self.marker_popup == MAP_MARKER_POPUP.PLACE_CARD) {

            const clickedElement = event.target;

            if (clickedElement.classList.contains('Action')) {
                const className = clickedElement.classList.item(0);
                const itemId = clickedElement.getAttribute('id' + className);
                self.actionItemId.emit(itemId);
            }
        }
    }

    function offerMarkerOnOpen(e, marker) {
        let index = self.offerMarkersIconGroup.getLayers().indexOf(marker);
        if (place.itinerarySummary) {
            if (self.itineraryHighlightRow) self.itineraryHighlightRow.classList.remove('highlight');
            self.itineraryHighlightRow = document.getElementById('itemIndex' + index);
            if (self.itineraryHighlightRow) {
                self.itineraryHighlightRow.classList.add('highlight');
            }
        }
        self.clickedIndex.emit(index);

        const popup = marker.getPopup().getElement();
        popup.addEventListener('click', onClickOpenedPopup);
    }

    function offerMarkerOnClose(e, marker) {
        let index = self.offerMarkersIconGroup.getLayers().indexOf(marker);
        if (place.itinerarySummary) {
            if (self.itineraryHighlightRow) self.itineraryHighlightRow.classList.remove('highlight');
        }
        const popup = marker.getPopup().getElement();
        popup.removeEventListener('click', onClickOpenedPopup);
    }

    function addMarkerPopup(placeMarker, item) {
        switch (self.marker_popup) {
            case MAP_MARKER_POPUP.PLACE_NAME:
                placeMarker.bindPopup(item.name[0], {
                    closeButton: false
                });
                break;
            case MAP_MARKER_POPUP.PLACE_CARD:
/*
                var popupContent = `
                            <div class="popup_content">
                            <img class="image" src=${item.image_landscape} alt="">
                            <div class="name">${item.name[0]}</div>
                            <div class="time">${item.start?item.start.format("HH:mm")+ '-':''} ${item.end?item.end.format("HH:mm"):''}</div>
                            <ion-icon class="Action" idAction = ${item._id} src="data:image/svg+xml;utf-8,${encodeURIComponent(item.action_icon)}" 
                            size="small"></ion-icon>
                            </div>
                    `;
*
                var popupContent = `
                            <div class="popup_content">
                            <img class="image" src=${item.image_landscape} alt="">
                            <div class="name">${item.name[0]}</div>
                            <div class="time">${item.start?item.start.format("HH:mm")+ '-':''} ${item.end?item.end.format("HH:mm"):''}</div>
                            <ion-icon class="Action" idAction = ${item._id} src="${item.action_icon}" 
                            size="small"></ion-icon>
                            </div>
                    `;
                placeMarker.bindPopup(popupContent, {
                    closeButton: false,
                    className: 'popup_content'
                });
                break;
            default:
                placeMarker.bindPopup(item.name[0], {
                    closeButton: false
                });
                break;
        }
    }

    function addIconMarkers(item, coordinates) {
        const placeMarker = L.marker([coordinates.latitude, coordinates.longitude], {
            icon: L.icon({
                iconUrl: item.map_marker.icon,
                iconSize: [MAP_MARKER_SIZE.ICON, MAP_MARKER_SIZE.ICON]
            }),
            _id: item._id
        });
        addMarkerPopup(placeMarker, item);

        self.placeService.addMarker(zoomLevel, placeMarker)
        self.offerMarkersIconGroup.addLayer(placeMarker);
    }

    function addDotMarkers(item, coordinates) {
        const dotMarker = L.marker([coordinates.latitude, coordinates.longitude], {
            icon: L.icon({
                iconUrl: item.map_marker.dot,
                iconSize: [MAP_MARKER_SIZE.ICON, MAP_MARKER_SIZE.ICON]
            }),
            _id: item._id
        });
        addMarkerPopup(dotMarker, item);
        self.offerMarkersDotGroup.addLayer(dotMarker);
    }

    if (place._id > 0) {
        if (Array.isArray(place.coordinates)) {
            place.coordinates.forEach((item, index) => {
                const placeMarker = L.marker([item.coordinates.latitude, item.coordinates.longitude], {
                    icon: L.icon({
                        iconUrl: item.map_marker.pin,
                        iconSize: [MAP_MARKER_SIZE.PIN, MAP_MARKER_SIZE.PIN]
                    })
                });
                this.placeMarkerGroup.addLayer(placeMarker);
            });
        } else {
            this.placeMarkerGroup.addLayer(L.marker([place.coordinates.latitude, place.coordinates.longitude], {
                icon: L.icon({
                    iconUrl: place.map_marker.pin,
                    iconSize: [MAP_MARKER_SIZE.PIN, MAP_MARKER_SIZE.PIN]
                })
            }));
        }
    }

    if (offer_list) {
        var action_icon;
        offer_list.forEach((item, index) => {
            if (item.start){
                  action_icon = "assets/images/move.svg";
//                action_icon = ACTION_ICONS.MOVE.substring(ACTION_ICONS.MOVE.indexOf('<svg'));
            }
            else {
                  action_icon = "assets/images/bookmark.svg"
//                action_icon = ACTION_ICONS.COLLECT.substring(ACTION_ICONS.COLLECT.indexOf('<svg'));
            }
            item.action_icon = action_icon;
            if (!this.markersAdded.has(item._id) && !this.savedMarkersAdded.has(item._id)) {
                if (Array.isArray(item.coordinates)) {
                    item.coordinates.forEach((coordinates) => {
                        addIconMarkers(item, coordinates);
                    });
                } else {
                    addIconMarkers(item, item.coordinates);
                }

                if (place._id >= 0) {
                    if (Array.isArray(item.coordinates)) {
                        item.coordinates.forEach((coordinates) => {
                            addDotMarkers(item, coordinates);
                        });
                    } else {
                        addDotMarkers(item, item.coordinates);
                    }
                }
                this.markersAdded.add(item._id);
            }
        });

console.log(this.markersAdded.size+" markers added in zoom "+zoomLevel)

        this.offerMarkersIconGroup.eachLayer(function(marker, index) {
            marker.on('popupopen', (e) => offerMarkerOnOpen(e, marker));
            marker.on('popupclose', (e) => offerMarkerOnClose(e, marker));
        });

        this.mapOSM.addLayer(this.offerMarkersIconGroup);

        if (place.itinerarySummary) {

            this.infoBoxControl = L.control({
                position: 'topleft'
            });

            this.infoBoxControl.onAdd = function(map) {
                // Create the container for the side box
                const container = L.DomUtil.create('div', 'custom-control-class');
                // Add your content to the container (directions, information, etc.)
                container.innerHTML = place.itinerarySummary;
                container.addEventListener('click', event => {
                    const clickedElement = event.target;
                    if (clickedElement.classList.contains('TimeColumn') || clickedElement.classList.contains('PlaceColumn')) {
                        const className = clickedElement.classList.item(0);
                        const itemId = clickedElement.getAttribute('id' + className);
                        const markers = self.offerMarkersIconGroup.getLayers();
                        let poiLatLng = markers[itemId].getLatLng();
                        self.mapOSM.setView([poiLatLng.lat, poiLatLng.lng], self.mapOSM.getZoom());
                        setTimeout(() => {
                            markers[itemId].openPopup();
                        }, 500);
                    }
                });
                return container;
            };
            this.infoBoxControl.addTo(this.mapOSM);
        }

    } else {
        this.mapOSM.addLayer(this.placeMarkerGroup);
        this.mapOSM.addLayer(this.offerMarkersIconGroup)
    }
    this.mapOSM.addLayer(this.savedMarkersIconGroup);

    if (turfArea) {
        if (!turfExploredArea) {
            turfExploredArea = turf.polygon([turfArea]);
        } else {
            turfExploredArea = turf.union(turfExploredArea, turf.polygon([turfArea]));
        }
        this.placeService.setTurfExploredArea(zoomLevel, turfExploredArea);
    }
    if (!_update) {
        if (this._flyToDestination) {
            this._flying = true;
            this.mapOSM._handlers.forEach(function(handler) {
                handler.disable();
            });
            this.mapOSM.flyTo([place.coordinates.latitude, place.coordinates.longitude], zoomLevel, {
                duration: MAP_FLY_DURATION.CURRENT_TO_DESTINATION
            })
            await new Promise(resolve => setTimeout(resolve, MAP_FLY_DURATION.CTD_WAIT));
            this.mapOSM._handlers.forEach(function(handler) {
                handler.enable();
            });
            this._flying = false;

        } else {
            //this.mapOSM.setView([place.coordinates.latitude, place.coordinates.longitude], zoomLevel);
            /*        
            if (!this.unselectedPlace){
                if (!_update) this.mapOSM.setView([place.coordinates.latitude, place.coordinates.longitude], zoomLevel);
            }
            else {
                this.mapOSM.setView([this.unselectedPlace.center.lat,this.unselectedPlace.center.lng],this.unselectedPlace.zoom_level);
                this.unselectedPlace = null;
            }
            /**
            if (this.mapOSM.hasLayer(this.offerMarkersIconGroup)) {
                this.mapOSM.fitBounds(this.offerMarkersIconGroup.getBounds());
            } 
            /**
            else if (this.mapOSM.hasLayer(this.offerMarkersDotGroup)) {
                this.mapOSM.fitBounds(this.offerMarkersIconGroup.getBounds());
            }
            **
            else {
                this.mapOSM.setView([place.coordinates.latitude, place.coordinates.longitude], zoomLevel);
            }
            /**
        }
        if (this.search_filter > 0) {
            this.currentCenter = this.mapOSM.getCenter();
            console.log("center: " + JSON.stringify(this.currentCenter))
            this.currentZoom = zoomLevel;
//            this.setViewCenter(true, this.currentCenter, zoomLevel);
        }

    } else if (this._changingMap) {
        if (!this.previousViewPlace || place._id == CURRENT_PLACE._id) {
            this.mapOSM.setView([place.coordinates.latitude, place.coordinates.longitude], zoomLevel);
        } else {
            this.mapOSM.setView([this.previousViewPlace.center.lat, this.previousViewPlace.center.lng], this.previousViewPlace.zoom_level);
            this.previousViewPlace = null;
        }
        this._changingMap = false;
    }
    checkCurrentLocationInView();
//    this._map_ready.emit(currentRequest);
    /*        
    let waypoints = place.marker_list.map(function (poi) {
        return L.latLng(poi.coordinates.latitude,poi.coordinates.longitude);
      })
      
    var routingControl = L.Routing.control({
      waypoints: waypoints,
      createMarker: function() { return null; },
      show:false,
    }).addTo(this.mapOSM);
    *
    
    function checkCurrentLocationInView () {
          if (self.currentLocationMarker){
          const mapBounds = self.mapOSM.getBounds();
          const markerLatLng = self.currentLocationMarker.getLatLng();

          let _isMyLocationInView = mapBounds.contains(markerLatLng);
          if (self._isMyLocationInView != _isMyLocationInView){
              self._isMyLocationInView = _isMyLocationInView;
              self._myLocationInView.emit(_isMyLocationInView);
          }
          }
    }

    function updateMarkerGroupsBasedOnZoom() {

        var zoomLevel = self.mapOSM.getZoom();
        var center = self.mapOSM.getCenter();
        if (offer_list) {
            if (zoomLevel <= self.base_level - MAP_ZOOM_LEVEL.MARKER_THRESHOLD) {

                if (self.mapOSM.hasLayer(self.offerMarkersIconGroup)) self.mapOSM.removeLayer(self.offerMarkersIconGroup);
                if (self.mapOSM.hasLayer(self.offerMarkersDotGroup)) self.mapOSM.removeLayer(self.offerMarkersDotGroup);
                if (!self.mapOSM.hasLayer(self.placeMarkerGroup)) self.mapOSM.addLayer(self.placeMarkerGroup);
                self.previousViewPlace = {
                    center: self.mapOSM.getCenter(),
                    zoom_level: zoomLevel
                };
                if (!self._changingMap) {
                    self.unselectPlace.emit();
                    self._changingMap = true;
                }


            } else if (zoomLevel < self.base_level) {

                if (self.mapOSM.hasLayer(self.offerMarkersIconGroup)) self.mapOSM.removeLayer(self.offerMarkersIconGroup);
                if (self.mapOSM.hasLayer(self.placeMarkerGroup)) self.mapOSM.removeLayer(self.placeMarkerGroup);
                if (!self.mapOSM.hasLayer(self.offerMarkersDotGroup)) self.mapOSM.addLayer(self.offerMarkersDotGroup);

            } else {

                if (self.mapOSM.hasLayer(self.offerMarkersDotGroup)) self.mapOSM.removeLayer(self.offerMarkersDotGroup);
                if (self.mapOSM.hasLayer(self.placeMarkerGroup)) self.mapOSM.removeLayer(self.placeMarkerGroup);
                if (!self.mapOSM.hasLayer(self.offerMarkersIconGroup)) self.mapOSM.addLayer(self.offerMarkersIconGroup);

                if (zoomLevel > MAP_ZOOM_LEVEL.SMALL_COUNTRY) {
                    if (!self._changingMap) {
                        self._changingMap = self.zoomedInPlace();
                    }
                    if (self._changingMap) {
                        self.previousViewPlace = {
                            center: center,
                            zoom_level: zoomLevel
                        };
                    }
                }

            }
        }
        
        if (self.currentZoom != zoomLevel && self.search_filter >0) {
            self.currentCenter = center;
            self.currentZoom = zoomLevel;
//            self.setViewCenter(true, center, zoomLevel);
console.log("zoom level changed to " + zoomLevel)
        }
        checkCurrentLocationInView ()
    }

    function onMapMove() {
        if (self.search_filter > 0) {
            // Get the updated center coordinates
            const center = self.mapOSM.getCenter();
/*            if (!self.turfViewArea || (self.turfViewArea && !turf.booleanPointInPolygon(turf.point([center.lng, center.lat]), self.turfViewArea))) {
                self.currentCenter = center;
//                self.setViewCenter(false, center, self.currentZoom);
console.log("view center changed on zoom level " + self.currentZoom)
            }
*
        }
        checkCurrentLocationInView ()
    }

    /** zoom for different icons TBD *

    if (!_update) {

        // Call the function whenever the map zoom changes
        this.mapOSM.on('zoomend', updateMarkerGroupsBasedOnZoom);
        // Add an event listener to the 'move' event of the map
        this.mapOSM.on('moveend', onMapMove);


        this.screenOrientation.onChange().subscribe(() => {
            setTimeout(() => {
                if (self.mapOSM) {
                    self.mapOSM.invalidateSize();
                }
            }, 200);
        });
    }
    
*/
    }
    addMarkers(zoomLevel, item, coordinates, itinerarySummary?): any {
        let self = this;
        item.action_icon = "assets/images/bookmark.svg";
        addIconMarkers(item, coordinates);

        function addIconMarkers(item, coordinates) {
            const marker = L.marker([coordinates.latitude, coordinates.longitude], {
                icon: L.icon({
                    iconUrl: item.map_marker.icon,
                    iconSize: [MAP_MARKER_SIZE.ICON, MAP_MARKER_SIZE.ICON]
                }),
                _id: item._id
            });
            addMarkerPopup(marker, item);
            marker.on('popupopen', (e) => offerMarkerOnOpen(e, marker));
            marker.on('popupclose', (e) => offerMarkerOnClose(e, marker));
            self.placeService.addMarker(zoomLevel, marker);
            if (self.mapOSM.getZoom() == zoomLevel) {
                if (!self.markersAdded.has(marker.options._id)) {
                    self.placeDataMarkerGroup.addLayer(marker);
                    self.markersAdded.add(marker.options._id);
                }
            }
            //    self.offerMarkersIconGroup.addLayer(placeMarker);
        }

        function addDotMarkers(item, coordinates) {
            const dotMarker = L.marker([coordinates.latitude, coordinates.longitude], {
                icon: L.icon({
                    iconUrl: item.map_marker.dot,
                    iconSize: [MAP_MARKER_SIZE.DOT, MAP_MARKER_SIZE.DOT]
                }),
                _id: item._id
            });
            addMarkerPopup(dotMarker, item);
            dotMarker.on('popupopen', (e) => offerMarkerOnOpen(e, dotMarker));
            dotMarker.on('popupclose', (e) => offerMarkerOnClose(e, dotMarker));
            //    self.offerMarkersDotGroup.addLayer(dotMarker);
        }

        function addMarkerPopup(placeMarker, item) {
            switch (self.marker_popup) {
                case MAP_MARKER_POPUP.PLACE_NAME:
                    placeMarker.bindPopup(item.name[0], {
                        closeButton: false
                    });
                    break;
                case MAP_MARKER_POPUP.PLACE_CARD:
                    /*
                                    var popupContent = `
                                                <div class="popup_content">
                                                <img class="image" src=${item.image_landscape} alt="">
                                                <div class="name">${item.name[0]}</div>
                                                <div class="time">${item.start?item.start.format("HH:mm")+ '-':''} ${item.end?item.end.format("HH:mm"):''}</div>
                                                <ion-icon class="Action" idAction = ${item._id} src="data:image/svg+xml;utf-8,${encodeURIComponent(item.action_icon)}" 
                                                size="small"></ion-icon>
                                                </div>
                                        `;
                    */
                    var popupContent = `
                            <div class="popup_content">
                            <img class="image" src=${item.image_landscape} alt="">
                            <div class="name">${item.name[0]}</div>
                            <div class="time">${item.start?item.start.format("HH:mm")+ '-':''} ${item.end?item.end.format("HH:mm"):''}</div>
                            <ion-icon class="Action" idAction = ${item._id} src="${item.action_icon}" 
                            size="small"></ion-icon>
                            </div>
                    `;
                    placeMarker.bindPopup(popupContent, {
                        closeButton: false,
                        className: 'popup_content'
                    });
                    break;
                default:
                    placeMarker.bindPopup(item.name[0], {
                        closeButton: false
                    });
                    break;
            }
        }

        function onClickOpenedPopup(event) {
            /*
            console.log("emitting selected index "+index);
                                    self.selectedIndex.emit(index);
            */
            if (self.marker_popup == MAP_MARKER_POPUP.PLACE_CARD) {
                const clickedElement = event.target;
                if (clickedElement.classList.contains('Action')) {
                    const className = clickedElement.classList.item(0);
                    const itemId = clickedElement.getAttribute('id' + className);
                    self.actionItemId.emit(itemId);
                }
            }
        }

        function offerMarkerOnOpen(e, marker) {
            var markersGroup;
            if (self.mapOSM.hasLayer(self.offerMarkersIconGroup)) {
                markersGroup = self.offerMarkersIconGroup;
            } else if (self.mapOSM.hasLayer(self.offerMarkersDotGroup)) {
                markersGroup = self.offerMarkersDotGroup;
            } else if (self.mapOSM.hasLayer(self.placeDataMarkerGroup)) {
                markersGroup = self.placeDataMarkerGroup;
            }
            let index = markersGroup.getLayers().indexOf(marker);
            if (itinerarySummary) {
                if (self.itineraryHighlightRow) self.itineraryHighlightRow.classList.remove('highlight');
                self.itineraryHighlightRow = document.getElementById('itemIndex' + index);
                if (self.itineraryHighlightRow) {
                    self.itineraryHighlightRow.classList.add('highlight');
                }
            }
            self.clickedIndex.emit(index);
            self._markerPopup = true;
            const popup = marker.getPopup().getElement();
            popup.addEventListener('click', onClickOpenedPopup);
        }

        function offerMarkerOnClose(e, marker) {
            var markersGroup;
            if (self.mapOSM.hasLayer(self.offerMarkersIconGroup)) {
                markersGroup = self.offerMarkersIconGroup;
            } else if (self.mapOSM.hasLayer(self.offerMarkersDotGroup)) {
                markersGroup = self.offerMarkersDotGroup;
            } else if (self.mapOSM.hasLayer(self.placeDataMarkerGroup)) {
                markersGroup = self.placeDataMarkerGroup;
            }
            let index = markersGroup.getLayers().indexOf(marker);
            if (itinerarySummary) {
                if (self.itineraryHighlightRow) self.itineraryHighlightRow.classList.remove('highlight');
            }
            const popup = marker.getPopup().getElement();
            popup.removeEventListener('click', onClickOpenedPopup);
        }
    }
    loadMarkers(zoom_level, bounds, _cleanup): any {
        let self = this;
        //let markers = this.placeService.getMarkers(zoom_level, this.mapOSM.getBounds());
        let markers = this.placeService.getMarkers(zoom_level, bounds);
        markers.forEach((marker) => {
            if (!self.markersAdded.has(marker.options._id)) {
                self.placeDataMarkerGroup.addLayer(marker);
                self.markersAdded.add(marker.options._id);
            }
        });
        if (_cleanup) {
            this.placeDataMarkerGroup.getLayers().forEach(m => {
                if (!markers.some(marker => marker.options._id == m.options._id)) {
                    self.placeDataMarkerGroup.removeLayer(m);
                    self.markersAdded.delete(m.options._id);
                }
            })
        }
    }
    constructor(public Apperyio: ApperyioHelperService, private $aio_mappingHelper: ApperyioMappingHelperService, private $aio_changeDetector: ChangeDetectorRef, public neurService: NeurService, public screenOrientation: ScreenOrientation, public placeService: PlaceService) {
        this.$a = this.Apperyio;
        this.$v = this.Apperyio.vars;
        this._flying = false;
        this._containerReady = false;
        this._changingMap = false;
        this._markerPopup = false;
        this.aioChangeDetector = this.$aio_changeDetector;
    }
}